export default "__VITE_ASSET__17jjRPip__"